.kdx-blog-listing {
    border-top: 1px solid #CCC;
    padding-top: 40px;
        
    .filters {
        
        .kdx-site-search.input-group > .form-control { height: 40px; }
        .kdx-site-search .input-group-text { 
            height: 38px;
            top: 1px;

            svg { transform: translateY(5px); }
        }
        .filter-headline {
            @include text-size(30);
            @include line-height(32);
            font-weight: 600;
            margin: 0 0 16px 0;
            color: $blogFilterHeadline;
        }
        .filter-group { margin-bottom: 40px; }        
        .category-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-left: 0;
            position: relative;
            margin-bottom: 8px;
            
            label {
                border: 1px solid #DEDEDE;
                border-radius: 4px;
                padding: 9px 40px 9px 12px;
                width: 100%;
                cursor: pointer;
                @include text-size(16);
                @include line-height(20);
                font-weight: 600;
                font-family: $font-family-secondary;
                transition: background .3s ease-in-out, color .3s ease-in-out;

                &:hover, &:focus {
                    background: $blogFilterHoverBG;
                    color: #FFF;
                }
            }
            .form-check-input {
                position: absolute;
                right: 12px;
                top: calc(50% - 3px);
                z-index: 2;
                background-color: #FFF;
                border: 1px solid #707070;
                border-radius: 2px;
                transform: translateY(-50%);

                &:hover, &:focus, &:checked {
                    background-color: transparent;
                    border-color: #FFF;
                    outline: none;
                    box-shadow: none;
                    
                    & ~ .form-check-label {
                        background: $blogFilterHoverBG;
                        color: #FFF;
                    }
                }
            }
        }
    }
    .results {
        .total-results {
            color: $blogTotalResultsLabel;
            @include text-size(20);
            @include line-height(32);
            font-family: $font-family-secondary;
            margin-bottom: 24px;
            
            .showing { font-weight: 600; }
            .keyword { font-style: italic; }            
        }
        .results-row {
            & > [class^="col-"] {
                margin-bottom: 32px;
            }
        }
    }    
}
.featured-articles-row {
    & > [class^="col-"] { margin-bottom: 16px; }
}







@include media-breakpoint-down(md) {
    
    .kdx-blog-listing {
        padding-top: 32px;

        .filters {

            .filter-headline {
                @include text-size(25);
                @include line-height(30);
            }
        }
        .results {

            .total-results {
                @include text-size(14);
                @include line-height(32);
            }
            .kdx-card {

                .card-img-top { display: none; }
            }
        }
    }
    .featured-articles-row {
        & > [class^="col-"]:last-child { margin-bottom: 0; }
    }
    
}